export default __webpack_public_path__ + "static/media/Department-icon.584c1500.svg";